import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Swal from "sweetalert2";
import { rsaService } from "../api/auth/rsaService";
import { sendOTPUsername } from "./Services/ForgetService";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login,loginWithOtp  } = useContext(AuthContext);
  const inputRef = useRef(null);

  const from = location.state?.from || "/";

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passError, setPassError] = useState("");


  // Load scripts
  useEffect(() => {
    const scriptUrls = [
      "assets/js/jquery-3.7.1.min.js",
      "assets/js/bootstrap.bundle.min.js",
      "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/intlTelInput.min.js",
      "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
      "assets/js/script.js",
    ];

    let isCancelled = false;

    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = url;
          script.async = false;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }

      if (!isCancelled && window.$?.fn?.datetimepicker) {
        window.$(".datetimepicker").datetimepicker();
      }

      if (!isCancelled && typeof window.initBackToTop === "function") {
        window.initBackToTop();
      }

      if (!isCancelled && window.intlTelInput) {
        window.intlTelInput(inputRef.current, {
          initialCountry: "in",
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
    };
  }, []);
  const [isLogin,setIsLogin] = useState(false);
  const [loginMode, setLoginMode] = useState('password');
const [otp, setOtp] = useState('');
const [otpSent, setOtpSent] = useState(false);
const [sendingOtp, setSendingOtp] = useState(false);
const [otpError, setOtpError] = useState('');
  // Password validation
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPass(value);

    if (value.length > 0 && (value.length < 8 || value.length > 20)) {
      setPassError("Password must be 8-20 characters long");
    } else {
      setPassError("");
    }
  };

  // ✅ Email OR Phone validation function
  const validateEmailOrPhone = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    return emailRegex.test(value) || phoneRegex.test(value);
  };

  // Handle Login
  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLogin(true);
    let isValid = true;

    if (!email) {
      setEmailError("E-mail / Phone is required");
      isValid = false;
    } else if (!validateEmailOrPhone(email)) {
      setEmailError("Enter valid email or 10-digit phone number");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (!pass) {
      setPassError("Password is required");
      isValid = false;
    } else if (pass.length < 8 || pass.length > 20) {
      setPassError("Password must be 8-20 characters long");
      isValid = false;
    } else {
      setPassError("");
    }

    if (!isValid){
      setIsLogin(false);
      return;
    } 

    try {
      const encrypted = await rsaService.encrypt(pass);

      const formData = {
        email: email,
        password: encrypted.cipherText,
        rasId: encrypted.keyId,
      };

      const response = await login(formData);

      navigate(from, { replace: true });
      window.history.replaceState({}, document.title);

      console.log(response);
    } catch (error) {
      console.error(error);

      Swal.fire({
        title: "Error!",
        text: "Please check your credentials.",
        icon: "error",
      });
    } finally {
        setIsLogin(false);
    }
  };

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <>
      <style>
        {`
        .pass-group {
          position: relative;
          display: flex;
          align-items: center;
        }

        .pass-group .pass-input {
          width: 100%;
          padding-right: 45px;
        }

        .pass-group span {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 18px;
          color: #6c757d;
          cursor: pointer;
        }

        .pass-group span:hover {
          color: #000;
        }
      `}
      </style>

      <div>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-8 offset-md-2">

                <div
                  className="account-content"
                  style={{
                    marginTop: "50px",
                    border: "1px solid #9f9b9b",
                    padding: "30px",
                    borderRadius: "8px",
                    boxShadow: "0 3px 8px rgba(0,0,0,0.24)",
                  }}
                >
                  <div className="row align-items-center justify-content-center">

                    <div className="col-md-7 col-lg-6 login-left">
                      <img
                        src="assets/img/login-banner.png"
                        className="img-fluid"
                        alt="Login"
                      />
                    </div>

                    <div className="col-md-12 col-lg-6 login-right">
                      <div className="login-header">
                        <h3>
                          Login <span>Webnet HMS</span>
                        </h3>
                      </div>

                      {/* ✅ Form */}
                      <form >

                        {/* Email / Phone */}
                        <div className="mb-3">
                          <label className="form-label">
                            E-mail / Phone
                          </label>
                          <input
                            ref={inputRef}
                            type="text"
                            className="form-control form-control-lg group_formcontrol form-control-phone"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                              if (e.target.value) setEmailError("");
                            }}
                            placeholder="Email or Phone Number"
                          />
                          {emailError && <small className="text-danger">{emailError}</small>}
                        </div>

                        {/* Password */}
                        {loginMode !== 'otp'?
                        <div className="mb-3">
                          <div className="form-group-flex">
                            <label className="form-label">Password</label>
                            <a href="/forget" className="forgot-link">
                              Forgot password?
                            </a>
                          </div>

                          <div className="pass-group">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control pass-input"
                              value={pass}
                              onChange={handlePasswordChange}
                            />

                            <span
                              onClick={togglePassword}
                              className={
                                showPassword
                                  ? "fa fa-eye"
                                  : "fa fa-eye-slash"
                              }
                            />
                          </div>
                          {passError && <small className="text-danger">{passError}</small>}
                        </div>:<></>}

                        {/* Submit */}
                        <div className="mb-2">
                          <div className="text-center mb-2">
  <a href="/" role="button" className="forgot-link"
    onClick={(e) => { e.preventDefault(); setLoginMode(prev => prev === 'otp' ? 'password' : 'otp'); }}>
    {loginMode === 'otp' ? 'Login through password' : 'Login through otp'}
  </a>
</div>

{loginMode === 'otp' && (
  <div className="mb-3">

    {!otpSent ? (
      <button type="button" className="btn btn-primary w-100"
        disabled={sendingOtp}
        onClick={async () => {
          if (!validateEmailOrPhone(email)) {
            setOtpError("Enter valid email or 10-digit phone number"); return;
          }
          try {
            setSendingOtp(true);
            const res = await sendOTPUsername(email);
            if (res?.data?.statusCode === "OK") {
              setOtpSent(true); setOtpError('');
              Swal.fire({ title: 'OTP Sent!', text: res.data.data, icon: 'success', confirmButtonColor: '#566fe2' });
            } else {
              Swal.fire({ title: 'Error', text: res?.data?.data, icon: 'error' });
            }
          } catch (error) {
  Swal.fire({
    title: "Error",
    text: error?.response?.data?.data || "Something went wrong",
    icon: "error"
  });
}
          finally { setSendingOtp(false); }
        }}>
        {sendingOtp ? 'Sending...' : 'Send OTP'}
      </button>
    ) : (
      <>
        <div className="mb-3">
          <label className="form-label">Enter OTP</label>
          <input
            type="text"
            className="form-control"
            maxLength={6}
            value={otp}
            onChange={(e) => { if (/^[0-9]*$/.test(e.target.value)) { setOtp(e.target.value); setOtpError(''); } }}
            placeholder="6-digit OTP"
          />
          {otpError && <small className="text-danger">{otpError}</small>}
        </div>
        <button type="button" className="btn btn-success w-100"
          onClick={async () => {
            if (otp.length !== 6) { setOtpError("OTP must be 6 digits"); return; }
            try {
              await loginWithOtp(email, otp);
              navigate(from, { replace: true });
              window.history.replaceState({}, document.title);
            } catch (err) {
              Swal.fire("Error", err.message || "OTP login failed", "error");
            }
          }}>
          Verify OTP & Login
        </button>
      </>
    )}
  </div>
)}
{loginMode !== 'otp'?
                          <button
                            className="btn btn-primary-gradient w-100"
                            type="submit"
                            onClick={handleLogin}
                            disabled={isLogin}
                          >
                            {(isLogin)?"Loading ... ":"Sign in"}
                          </button>:<></>
}
                        </div>

                        <div className="account-signup">
                          <p>
                            Don't have an account ?{" "}
                            <a
                              href="/sign-up"
                              className="btn btn-md btn-primary-gradient d-inline-flex align-items-center rounded-pill"
                            >
                              Sign up
                            </a>
                          </p>
                        </div>

                      </form>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}